const rightHandedWords = [
	'hi',
	'hili',
	'hill',
	'hillo',
	'hilly',
	'hilum',
	'him',
	'hin',
	'hinny',
	'hip',
	'hippo',
	'hippy',
	'hm',
	'hmm',
	'ho',
	'hokily',
	'hokku',
	'hokum',
	'hokypoky',
	'holily',
	'holk',
	'hollo',
	'holloo',
	'holly',
	'holm',
	'holmium',
	'holp',
	'holy',
	'homily',
	'hominy',
	'homonym',
	'homonymy',
	'homophony',
	'homy',
	'hon',
	'honk',
	'honky',
	'hook',
	'hookup',
	'hooky',
	'hooly',
	'hoop',
	'hoopoo',
	'hop',
	'hoppy',
	'hoy',
	'huh',
	'huipil',
	'hulk',
	'hulky',
	'hull',
	'hullo',
	'hum',
	'hump',
	'humph',
	'humpy',
	'hun',
	'hunh',
	'hunk',
	'hunky',
	'hup',
	'hymn',
	'hyp',
	'hypo',
	'hypolimnion',
	'hypopyon',
	'ikon',
	'ilium',
	'ilk',
	'ill',
	'illinium',
	'illy',
	'imino',
	'immy',
	'imp',
	'impi',
	'imply',
	'in',
	'inion',
	'ink',
	'inky',
	'inly',
	'inn',
	'inulin',
	'ion',
	'ionium',
	'jill',
	'jillion',
	'jiminy',
	'jimminy',
	'jimmy',
	'jimp',
	'jimply',
	'jimpy',
	'jin',
	'jink',
	'jinn',
	'jinni',
	'jo',
	'john',
	'johnny',
	'join',
	'jokily',
	'joky',
	'jollily',
	'jolly',
	'jouk',
	'joy',
	'joypop',
	'juju',
	'jump',
	'jumpily',
	'jumpy',
	'jun',
	'junk',
	'junky',
	'jupon',
	'khi',
	'khoum',
	'kilim',
	'kill',
	'killjoy',
	'kiln',
	'kilo',
	'kimono',
	'kin',
	'kinin',
	'kino',
	'kip',
	'knoll',
	'knolly',
	'knop',
	'kohl',
	'koi',
	'kolo',
	'konk',
	'kook',
	'kooky',
	'kop',
	'koph',
	'li',
	'lily',
	'limn',
	'limo',
	'limp',
	'limpkin',
	'limply',
	'limuli',
	'limy',
	'lin',
	'linin',
	'link',
	'linkup',
	'linky',
	'linn',
	'lino',
	'linum',
	'liny',
	'lion',
	'lip',
	'lipin',
	'lippy',
	'lo',
	'loin',
	'loll',
	'lollipop',
	'lollop',
	'lolly',
	'lollypop',
	'loo',
	'look',
	'lookup',
	'loom',
	'loon',
	'loony',
	'loop',
	'loopy',
	'lop',
	'loppy',
	'loup',
	'lull',
	'lulu',
	'lum',
	'lump',
	'lumpily',
	'lumpy',
	'lunk',
	'luny',
	'lupin',
	'lupulin',
	'lymph',
	'mho',
	'mi',
	'mil',
	'milium',
	'milk',
	'milkily',
	'milky',
	'mill',
	'millimho',
	'milliohm',
	'million',
	'milo',
	'mim',
	'mini',
	'minikin',
	'minim',
	'minimill',
	'minimum',
	'minion',
	'minium',
	'mink',
	'minny',
	'mm',
	'mo',
	'moil',
	'mojo',
	'mol',
	'moll',
	'molly',
	'moly',
	'mom',
	'momi',
	'mommy',
	'mon',
	'monk',
	'mono',
	'monohull',
	'monophony',
	'monophyly',
	'monopoly',
	'mony',
	'moo',
	'mool',
	'moon',
	'moonily',
	'moony',
	'mop',
	'mopy',
	'moujik',
	'moulin',
	'mu',
	'muhly',
	'mujik',
	'mukluk',
	'mull',
	'mullion',
	'mum',
	'mumm',
	'mummy',
	'mump',
	'mumu',
	'mun',
	'muni',
	'munnion',
	'muon',
	'muonium',
	'muumuu',
	'my',
	'myopy',
	'nihil',
	'nil',
	'nill',
	'nim',
	'ninny',
	'ninon',
	'nip',
	'nippily',
	'nippy',
	'no',
	'noh',
	'noil',
	'noily',
	'nolo',
	'nom',
	'nomoi',
	'nonillion',
	'nonoily',
	'nonunion',
	'nonyl',
	'noo',
	'nook',
	'nooky',
	'noon',
	'noun',
	'nu',
	'null',
	'nun',
	'nylon',
	'nymph',
	'nympho',
	'oh',
	'ohm',
	'oho',
	'oil',
	'oilily',
	'oily',
	'oink',
	'olio',
	'om',
	'on',
	'onion',
	'oniony',
	'onium',
	'only',
	'ooh',
	'oomph',
	'op',
	'opinion',
	'opium',
	'ouph',
	'oy',
	'phi',
	'phon',
	'phonily',
	'phono',
	'phonon',
	'phony',
	'phyllo',
	'phylon',
	'phylum',
	'pi',
	'piki',
	'pili',
	'pill',
	'pillion',
	'pily',
	'pimp',
	'pimply',
	'pin',
	'pinion',
	'pink',
	'pinkly',
	'pinko',
	'pinky',
	'pinny',
	'pinon',
	'pinup',
	'piny',
	'pinyin',
	'pinyon',
	'pion',
	'pip',
	'pipkin',
	'pippin',
	'pipy',
	'piu',
	'plink',
	'plonk',
	'plop',
	'ploy',
	'plum',
	'plummy',
	'plump',
	'plumply',
	'plumy',
	'plunk',
	'ply',
	'poh',
	'poi',
	'poilu',
	'pokily',
	'poky',
	'pol',
	'polio',
	'poll',
	'pollinium',
	'polo',
	'polonium',
	'poly',
	'polynyi',
	'polyp',
	'polyphony',
	'polypi',
	'pom',
	'pommy',
	'pomp',
	'pompom',
	'pompon',
	'pony',
	'pooh',
	'pool',
	'poon',
	'poop',
	'pop',
	'poplin',
	'poppy',
	'poyou',
	'pul',
	'puli',
	'pulik',
	'pull',
	'pullup',
	'pulp',
	'pulpily',
	'pulpy',
	'pump',
	'pumpkin',
	'pun',
	'punily',
	'punk',
	'punkin',
	'punky',
	'punny',
	'puny',
	'pup',
	'pupil',
	'puppy',
	'pyin',
	'pylon',
	'uh',
	'ulu',
	'um',
	'umm',
	'ump',
	'un',
	'unhip',
	'unholily',
	'unholy',
	'unhook',
	'union',
	'unlink',
	'unpin',
	'up',
	'uphill',
	'uplink',
	'upo',
	'upon',
	'yill',
	'yin',
	'yip',
	'yo',
	'yok',
	'yolk',
	'yolky',
	'yom',
	'yomim',
	'yon',
	'yoni',
	'you',
	'youpon',
	'yuk',
	'yum',
	'yummy',
	'yup',
	'yupon',
];

module.exports = rightHandedWords;



// WEBPACK FOOTER //
// ./js/dicts/right_handed.js